import * as d3 from 'd3';
import $ from 'jquery';

function serialize(node: SVGSVGElement, style?: string, font?: SVGElement): string {
  // Serialize a given jquery object into valid SVG string
  node = node.cloneNode(true) as SVGSVGElement;
  $(node).find('[data-original-title]').removeAttr('data-original-title');
  $(node).find('[title]').removeAttr('title');

  // Insert defs as first child of svg so Inkscape recognizes it
  const defs: d3.Selection<SVGSVGElement, unknown, null, undefined> = d3
    .select(node)
    .insert('svg:defs', ':first-child');

  if (style != null) {
    defs.append('svg:style').text(style);
  }
  if (font != null) {
    $(defs.node()!).append(font);
  }

  // oxlint-disable-next-line no-control-regex
  return new XMLSerializer().serializeToString(node).replace(/[\u0000-\u001f]+/g, '');
}

export {serialize};
